/*
 * @Description:油款票
 * @Author: WangYuhan
 * @Date: 2022-11-02 16:57:25
 * @LastEditTime: 2024-04-24 10:42:20
 * @LastEditors: lijinpeng
 */
// 引入api请求方法
import { tranType } from '@/utils/dictionary/freight';
import { oilConsumeDetail, exportOilConsumeDetail, tranPageList, tranExport } from '@/api/account';

const storeModuleName = 'oilModule';

const state = {
  // 筛选项-
  parameters: [
    {
      style: 'select',
      param: 'businessId',
      isFixed: true,
      value: '',
      valueType: 'string',
      state: 'companyList',
      label: '企业',
      placeholder: '请选择',
      noMatchText: '无匹配企业',
      clearable: false,
      filterable: false,
      path: `${storeModuleName}/getCompanyList`,
    },
    {
      style: 'input',
      value: '',
      label: '交易编号',
      placeholder: '请输入',
      clearable: true,
      param: 'id',
    },
    {
      style: 'select',
      param: 'tranType',
      value: '',
      valueType: 'string',
      state: 'tranType',
      label: '变动类型',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
    },
    {
      style: 'date-picker',
      param: 'insertTime',
      value: [],
      valueType: 'date',
      label: '变动时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['changeStartTime', 'changeEndTime'],
    },
  ],
  // 导出
  isExport: {
    isShow: true,
    method: 'post',
    url: tranExport,
  },
  // 页码
  postParams: {
    page: 1,
    size: 20,
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '交易编号',
        prop: 'id',
        width: 120,
        fixed: 'left',
        checked: 1,
        sortable: true,
      },
      {
        label: '企业名称',
        prop: 'businessName',
        width: 120,
        checked: 1,
        sortable: true,
      },
      {
        label: '变动金额（元）',
        prop: 'amount',
        width: 100,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-amount',
      },
      {
        label: '变动类型',
        prop: 'tranType',
        width: 100,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-tranType',
      },
      {
        label: '变动时间',
        prop: 'changeTime',
        width: 120,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-changeTime',
      },

      {
        label: '备注',
        prop: 'remarks',
        width: 140,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-remarks',
      },
    ],
    total: 0,
    sumAmount: 0,
  },
  businessId: '', // 所选企业ID
  channelInfos: [], // 网络货运平台列表
  tranType, // 轨迹
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.value === 'string') {
          params[item.param] = item.value.toString();
        } else {
          params[item.param] = item.value;
        }
      }
      if (item.style === 'date-picker' && item.value.length > 0) {
        params[item.params[0]] = `${item.value[0]} 00:00:00`;
        params[item.params[1]] = `${item.value[1]} 23:59:59`;
      }
    });
    const { data } = await tranPageList(Object.assign({}, params, context.state.postParams));
    context.commit('updateState', {
      key: 'listData',
      value: Object.assign({}, { tableHeadList: context.state.listData.tableHeadList }, data),
    });
    return data.list;
  },
  // 获取企业列表
  getCompanyList: async (context, payload) => {
    const data = JSON.parse(localStorage.getItem('group'));
    if (data && data.id) {
      // 只展示实名认证的企业列表
      context.commit('updateState', {
        key: 'payPwdExist',
        value: data.payPwdExist,
      });
      context.commit('updateState', {
        key: 'payPwdStatus',
        value: data.payPwdStatus,
      });
      const list = data.corporations.filter(item => item.realNameAudit === 1);
      if (list.length) {
        list.forEach(item => {
          item.label = item.principalPartName;
          item.value = item.businessId;
        });
      }
      context.commit('updateState', {
        key: 'companyList',
        value: list,
      });
    }
  },
};
// mutations
const mutations = {
  // 重置所有状态
  initFilter(state) {
    state.postParams = {
      page: 1,
      size: 20,
    };
    state.parameters.forEach(item => {
      if (item.isFixed) {
        return;
      }
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.style !== 'input-multiple') {
          item.value = [];
        } else {
          item.value = '';
        }
      }
      if (item.style === 'date-picker') {
        item.value = [];
      }
    });
  },
  // 更新state数据
  updateState(state, { key, value }) {
    state[key] = value;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    state.parameters[payload.index].value = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
